import React from "react";
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from "recharts";

// const data = [
//   { month: "Jan", bidEvents: 30, hoursSaved: 50 },
//   { month: "Feb", bidEvents: 32, hoursSaved: 40 },
//   { month: "Mar", bidEvents: 35, hoursSaved: 60 },
//   { month: "Apr", bidEvents: 40, hoursSaved: 70 },
//   { month: "May", bidEvents: 42, hoursSaved: 65 },
//   { month: "Jun", bidEvents: 38, hoursSaved: 80 },
// ];

const CustomizedTick = ({ x, y, payload }) => {
	return (
		<g transform={`translate(${x},${y})`}>
			<text
				x={0}
				y={0}
				dy={5}
				textAnchor="end"
				transform="rotate(270)"
				fill="#616161"
				style={{ fontSize: "14px" }}
			>
				{payload.value}
			</text>
		</g>
	);
};

const CustomTooltip = ({ active, payload, label }) => {
	if (active && payload && payload.length) {
		return (
			<div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10 }}>
				<div >{`${payload[0]['payload']['month']}`}</div>
				<div style={{ color: "#33ABDA" }}>Bid Events: {`${payload[0]['payload']['totalBidEvents']}`}</div>
				<div style={{ color: "#B05788" }}>Hours Saved: {`${payload[0]['payload']['hoursSaved']}`}</div>
			</div>
		);
	}

	return null;
};

// function sortDataByMonth(data) {
// 	const monthOrder = [
// 		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
// 	];

// 	return data?.slice().sort((a, b) => {
// 		const monthA = monthOrder.indexOf(a?.month.split(' ')[0]);
// 		const monthB = monthOrder.indexOf(b?.month.split(' ')[0]);

// 		return monthA - monthB;
// 	});
// }

const ArchletLineChart = ({ data }) => {

	const sortedData = data; // sortDataByMonth(data)
	const maxHoursSaved = Math.max(...data.map(item => parseFloat(item.hoursSaved)));
	const maxTotalBidEvents = Math.max(...data.map(item => parseFloat(item.totalBidEvents)));
	const maxLength = data.length === 1 ? 250 : data.length < 5 ? 50 : 32

	return (
		// <div style={{ width: "100%", height: "200px", overflowY: "auto" }}>
		// 	<div style={{ width: '100%', height: `${data.length * maxLength}px`, minHeight:"220px" }} >
		// <ResponsiveContainer width="100%" height={'100%'}>
		<ResponsiveContainer width="100%" height={300}>
			<LineChart
				data={sortedData}
				margin={{
					top: 20,
					right: 10,
					left: 10,
					bottom: 30,
				}}
			>
				<CartesianGrid horizontal={true} vertical={false} stroke='#DFDFDF' />
				<XAxis dataKey="month" tickLine={false} tick={<CustomizedTick />} interval={0} />
				<YAxis yAxisId="left"
					axisLine={false}
					tickLine={false}
					allowDecimals={false}
					domain={[0, maxTotalBidEvents]}
					// allowDataOverflow={true}
					label={{
						value: "Total Bid Events",
						angle: -90, position: "insideLeft", textAnchor: "middle",
						dy: 50,
						style: { fontSize: "16px", fontWeight: "700", fill: "#616161" },
					}} />
				<YAxis
					yAxisId="right"
					orientation="right"
					axisLine={false} tickLine={false}
					allowDecimals={false}
					domain={[0, maxHoursSaved]}
					// allowDataOverflow={true}
					label={{
						value: "Hours Saved", angle: -90, position: "insideRight",
						textAnchor: "middle", dy: -50,
						style: { fontSize: "16px", fontWeight: "700", fill: "#616161" },
					}}
				/>
				<Tooltip content={<CustomTooltip />} />
				<Line
					yAxisId="left"
					type="linear"
					dataKey="totalBidEvents"
					stroke="#33ABDA"
					dot={{ fill: "#33ABDA", stroke: "#33ABDA", strokeWidth: 2 }}
					strokeWidth={3}
				/>
				<Line
					yAxisId="right"
					type="linear"
					dataKey="hoursSaved"
					stroke="#B05788"
					dot={{ fill: "#B05788", stroke: "#B05788", strokeWidth: 2 }}
					strokeWidth={3}
				/>
			</LineChart>
		</ResponsiveContainer>
		// 	</div>
		// </div>
	);
};

export default ArchletLineChart;
